import { registerRootComponent } from 'expo';

import App from './App';

// Catch fatal JS errors and log them instead of letting the app silently
// terminate with no visible message (helps diagnose "app just exits" crashes).
if (typeof ErrorUtils !== 'undefined' && ErrorUtils.setGlobalHandler) {
    const defaultHandler = ErrorUtils.getGlobalHandler && ErrorUtils.getGlobalHandler();
    ErrorUtils.setGlobalHandler((error, isFatal) => {
        console.error('[GlobalErrorHandler]', isFatal ? 'FATAL' : 'non-fatal', error && error.message, error && error.stack);
        if (defaultHandler) {
            defaultHandler(error, isFatal);
        }
    });
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
